import API_BASE_URL from '../Config';

const getAuthHeader = () => ({
    'Authorization': `Bearer ${localStorage.getItem('token')}`
});

export const getMovimientosPaginados = async (page = 0, size = 10, search = '', sortField = 'fecha', sortDir = 'desc') => {
    try {
        const searchTerm = search ? encodeURIComponent(search.trim()) : '';
        const orderingParam = `${sortField},${sortDir}`;
        
        const url = `${API_BASE_URL}/transacciones/page?page=${page}&size=${size}&search=${searchTerm}&ordering=${orderingParam}`;
        
        const response = await fetch(url, {
            headers: getAuthHeader()
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(`Error ${response.status}: ${errorData.message || 'Error al obtener movimientos'}`);
        }
        
        return response.json();
    } catch (error) {
        console.error('Error fetching movimientos:', error);
        throw error;
    }
};
